import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../../../../services/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { SalesService } from '../../../sales.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from '../../../../../../environments/environment';
import { IconList } from '../../../../../../iconlist';
declare const $: any;
@Component({
  selector: 'app-receipt-refund-list',
  templateUrl: './receipt-refund-list.component.html',
  styleUrl: './receipt-refund-list.component.scss'
})
export class ReceiptRefundListComponent implements OnInit {
  @Input() paymentListData: any;
  @Output() changeModelStatus = new EventEmitter<any>();
  context: any
  paymentForm!: FormGroup
  dropdownMenu: any;
  addressProof = true
  BankN = false;
  exportSelectedType: string = '';
  ActionList: boolean = false;
  bankNameMandatory: boolean = false;
  projectId: any = null;
  siteId: any = null;
  frameworkComponents: any;
  paymentData!: any[];
  columnDefs!: any[];
  navigationId: any;
  defaultColDef: any;
  initials = [];
  picData: any;
  isDocument: boolean = false;
  chequeDetail = false;
  isEdit = false;
  filterTerm!: any;
  clientfileName = '';
  showExport: boolean = false;
  isDropdownOpen = false;
  overlayNoRowsTemplate: string = '<span>No records found</span>';
  fileName = '';
  excelStyles: any[] = [];
  gridOptions: any;
  showaddUpdateModal: boolean = false
  currentSelectedRecourd: any
  editIcon: string = environment.assetsImagePath + IconList.EditIconDropdown
  bookingIcon: string = environment.assetsImagePath + IconList.BookingIcon
  allotmentIcon: string = environment.assetsImagePath + IconList.AllotmentIcon

  selectedExportData: any[] = [];
  columnKeys: any[] = ['clientName', 'paymentType', 'sourceName',];
  keysToSearch: string[] = ['clientName', 'transactionNumber', 'amount', 'paymentType', 'paymentDate']
  editId: any;
  isClickable: any;

  constructor(private route: ActivatedRoute, public commonService: CommonService, private ngxSpinnerService: NgxSpinnerService,
    private saleservice: SalesService, private router: Router, private formBuilder: FormBuilder
  ) { this.context = this }

  ngOnInit() {
    this.saleservice.showpaymentAddUpdateData = false
    this.setSiteId();
    this.agGridHeaderList()
  }

  /**
   * Ag grid Header List
   */
  agGridHeaderList() {
    this.columnDefs = [

      {
        field: 'selection', columnType: 'checkbox'
      },
      {
        header: 'ClientName', field: 'clientName', columnType: 'text'
      },
      {
        header: 'Agent Name', field: 'sourceDetail', columnType: 'text'
      },
      {
        header: 'Mode of Receipt', field: 'paymentType', columnType: 'text'
      },
      {
        header: "Allocation Type", field: "allocationType", columnType: 'text'

      },
      {
        header: 'Amount', field: 'amount', columnType: 'text'
      },
      {
        header: 'Unit No.', field: 'unitName', columnType: 'text'
      },
      {
        header: 'Date of Receipt', field: 'paymentDate', columnType: 'text'
      },

      {
        header: 'Transaction No.', field: 'transactionNumber', columnType: 'text'
      },
      {
        header: 'Actions', field: 'options', columnType: 'dropdown', options: [
          { label: 'Booking', value: 'booking', icon: this.bookingIcon },
          { label: 'Allotment', value: 'allotment', icon: this.allotmentIcon },
          { label: 'Edit', value: 'edit', icon: this.editIcon }
        ]
      }
    ];
  }

  onCommonTableDropdownChange(event: { route: any, columnName: string, currentRow: any }) {
    const selectedRoute = event.route;
    if (selectedRoute == 'edit') {
      this.changeAddUpdateModalState(event?.currentRow)
    }
    else if (selectedRoute == 'booking') {
      this.routeBookingPage(event?.currentRow)
    } else if (selectedRoute == 'allotment') {
      this.routeAllotmentPage(event?.currentRow)
    }
  }

  changeAddUpdateModalState(currentRecord?: any) {
    const bookingId = this.route.snapshot.paramMap.get("bookingId")!;
    const paymentId = this.route.snapshot.paramMap.get("paymentId")!;
    this.changeModelStatus.emit({
      "showaddUpdateModal": true,
      "currentSelectedRecord": currentRecord,
    });
    if (currentRecord?.id != undefined && bookingId != undefined) {
      this.router.navigate(['sales/booking/' + currentRecord?.corelationId + '/receipt/' + currentRecord?.id]);
    }
  }
  /**
   * updating data on behalf of siteId
   */
  setSiteId() {
    this.siteId = this.commonService.localStorageSiteId;
  }

  /**
   * populating data of payment on behalf of project changed
   */
  getDataOnProjectLoad() {
    this.commonService.selectedProjects$.subscribe(project => {
      if (project) {
        this.projectId = project.id;
      }
    });
  }

  // Set Mobile View Control Update
  /**
   *
   * @param data enbale the payment detail to be edit
   */
  Editmodal(data: any) {
    this.editId = data.id;
    if (data.paymentType === "Cheque") {
      this.chequeDetail = true
    }
    else {
      this.chequeDetail = false
    }
    $("#banksN").attr('disabled', 'disabled');

    this.isEdit = true;
    this.paymentForm.controls['paymentType'].setValue(data.paymentType);
    if (data.paymentType === "Cheque") {
      this.chequeDetail = true
    }
    else {
      this.chequeDetail = false
    }
    // Click Payment Mode Cheque & Open Bank Name
    if (this.paymentForm.value.paymentType === "Cheque") {
      this.chequeDetail = true;
      this.BankN = this.bankNameMandatory ? true : false;
      $("#banksN").attr('disabled', 'disabled');
    }
    // Click Payment Mode NEFT & Open Bank Name
    else if (this.paymentForm.value.paymentType === "NEFT/RTGS/ IMPS") {
      this.BankN = this.bankNameMandatory ? true : false;
      this.paymentForm.controls['transactionNumber'].reset()
    }
    // Click Payment Mode PayTm & Hide Bank Name
    else if (this.paymentForm.value.paymentType === "PayTm") {
      this.BankN = false
      this.chequeDetail = false
    }
    // Click Payment Mode UPI & Open Bank Name
    else if (this.paymentForm.value.paymentType === "UPI") {
      this.chequeDetail = false
      this.BankN = this.bankNameMandatory ? true : false;
      this.paymentForm.controls['transactionNumber'].reset()
    }
    // Click Payment Mode Card & Hide Bank Name
    else if (this.paymentForm.value.paymentType === "Card Swipe") {
      this.BankN = false
      this.chequeDetail = false
      this.paymentForm.value.transactionNumber = "Crd" + this.commonService.getCurrentTimeStamp()
      this.paymentForm.controls['transactionNumber'].setValue("Crd" + this.commonService.getCurrentTimeStamp());
    } else if (this.paymentForm.value.paymentType === "Cash") {
      this.BankN = false
      this.chequeDetail = false
      this.paymentForm.value.transactionNumber = "Csh" + this.commonService.getCurrentTimeStamp()
      if (this.paymentForm.value.paymentType === "Cash") {
        this.paymentForm.controls['transactionNumber'].setValue("Csh" + this.commonService.getCurrentTimeStamp());
      } else {

      }
    }
    else {
      this.chequeDetail = false
    }
    // Data Value Set
    this.paymentForm.controls['bookingId'].setValue(data.bookingId);
    this.paymentForm.controls['amount'].setValue(data.amount.replace(/\,/g, ''));
    this.paymentForm.controls['paymentDate'].setValue(data.paymentDate = new Date(data.paymentDate));
    this.paymentForm.controls['transactionNumber'].setValue(data.transactionNumber);
    this.paymentForm.controls['id'].setValue(data.id);
    this.paymentForm.controls['remark'].setValue(data.remark);
    // this.paymentForm.controls['paymentTypeCopy'].setValue(data.paymentTypeCopy);
    this.paymentForm.controls['bankId'].setValue(data.bankDetail.id);
    this.paymentForm.controls['clientId'].setValue(data.customerDetail?.id);
    this.paymentForm.controls['paymentModeId'].setValue((data.paymentModeDetail) ? data.paymentModeDetail.id : 0);
    if (this.paymentForm.value.paymentType === "Cheque") {
      this.paymentForm.controls['chequeDate'].setValue(data.chequeDate = new Date(data.chequeDate));
    }
  }

  // Redirecting from Payment Action (Document) to Document page
  routeDocumentPage() {
    this.isDocument = true
    $("#adaharId").attr('disabled', 'disabled');
    $("#panId").attr('disabled', 'disabled');
    $("#bankName").attr('disabled', 'disabled');
    $("#bankAccountNo").attr('disabled', 'disabled');
    $("#ifscCode").attr('disabled', 'disabled');
    $("#bankAccountName").attr('disabled', 'disabled');
    $("#chequeId").attr('disabled', 'disabled');
    $("#voterId").attr('disabled', 'disabled');
    $("#addressProofNo").attr('disabled', 'disabled');
    this.
      addressProof = true
  }

  onSelectedRowsChange(selectedRows: any) {
    this.selectedExportData = [];
    let exportedObject: any[] = [];

    selectedRows.forEach((row: any) => {
      let customerDetailObject = row;
      if (customerDetailObject) {
        let rowData = {
          "Client Name": customerDetailObject?.clientName,
          "Agent Name": row?.sourceDetail,
          "Mode Of Payment": row.paymentModeDetail?.paymentModeName,
          "Allocation Type": row.allocationType,
          "Transaction Number": row.transactionNumber,
          "Date Of Payment": row.paymentDate,
          "Amount": row?.amount,
          "Unit No": row?.unitDescriptionDetail?.name,
        };
        exportedObject.push(rowData);
      }
    });

    this.selectedExportData = exportedObject;
  }
  /**
    *
    * @param {any} paymentId Redirecting from payment action trigerred option using paymentId
    */
  dropdownActonMenu(paymentId: any) {
    this.dropdownMenu = document.getElementById("actionMenuContent" + paymentId);
    this.dropdownMenu?.classList.toggle("dropdownActionMenu");
    this.ActionList = !this.ActionList;
  }

  //Showing modal on click of add payment button
  changeAddUpdateModelState() {
    this.changeModelStatus.emit({
      "showaddUpdateModal": true,
      "paymentToEdit": this.currentSelectedRecourd
    })
  }

  showModal() {
    this.changeModelStatus.emit({
      "showaddUpdateModal": true,
      "paymentToEdit": null
    })
  }

  //Showing modal on click of add payment button
  EditOptionClicked() {
    this.changeModelStatus.emit({
      "showaddUpdateModal": true,
    })
  }

  //to hide the export common component when needed
  hideExport() {
    this.showExport = false;
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  // Redirecting from Payment Action (Booking) to booking page using bookingID
  routeBookingPage(data: any) {
    this.router.navigate(['sales/receipt/' + data.corelationId + '/booking'])
  }

  // Redirecting from Payment Action (Booking) to booking page using bookingID
  routeAllotmentPage(data: any) {
    this.router.navigate(['sales/receipt/' + data.allotmentId + '/allotment'])
  }

  /**
  *
  * @param type toggle the export button and redirect the open common export-component
  */
  toggleExport(type: string) {
    this.exportSelectedType = type;
    this.showExport = !this.showExport;
  }

  /**
   *
   * @param data Set Data Mobile View Export Excel/PDF
   */
  exportValues(data: any) {
    if (data) {
      this.paymentForm.controls['sourceName'].setValue(data[0].sourceName);
      this.showExport = false;
    }
  }

  getPaymentDetails() {
    this.saleservice.getPaymentObserval().subscribe(data => {
      if (data) {
        this.paymentListData.push(data);
      }
    })
  }

  ngAfterViewInit() {
    this.route.queryParams.subscribe(p => {
      this.isClickable = p['isClickable'];
      if (this.isClickable) {
        document.getElementById('addPayment')?.click();
      }
    });
  }

  Close() {

  }
}
function ngAfterViewInit() {
  throw new Error('Function not implemented.');
}

